import { connect, Dispatch } from 'react-redux';
import { StoreState } from '../../reducers';

import DownloadGroupToast from '../../components/DownloadGroupToast';
import DownloadManagerUtils from '../../utils/downloadManager';
import {
	DownloadGroupName,
	DownloadGroupStatus,
} from '../DownloadManager/reducer';

const mapStateToProps = (state: StoreState) => {
	const {
		downloadManager,
		downloadManager: {
			isDownloadToastClosed,
			downloadGroups,
			pendingSelectedDownloads,
			totalSelectedDownloadsCount,
		},
		driveList,
		galleryInfos: {
			config: {
				applicationGallery,
				importantAssets,
			}
		},
	} = state;

	const pendingSelectedDownloadsCount = Object.keys(pendingSelectedDownloads).length;

	const isDownloadGroupStarted = [
		downloadGroups.all.status,
		downloadGroups.important.status,
		downloadGroups.selected.status,
	].includes(DownloadGroupStatus.Started);
	const enabledImportantTags = DownloadManagerUtils.getEnabledImportantTags(importantAssets);

	const downloadingGroup = DownloadManagerUtils.getDownloadingGroup(downloadGroups);
	const startedDownloadGroup = DownloadManagerUtils.getStartedDownloadGroup(downloadGroups);
	const isDownloading = downloadingGroup !== null;
	const loaderStepTagParam = downloadingGroup === DownloadGroupName.IMPORTANT ? enabledImportantTags : [];
	const loaderStep = DownloadManagerUtils.getGalleryLoaderStep(
		downloadManager,
		driveList,
		applicationGallery,
		isDownloading,
		loaderStepTagParam
	);
	const isDownloadingSelectedGroup = downloadingGroup === DownloadGroupName.SELECTED;

	let downloadedCount: number;
	let totalCount: number;

	if (isDownloadingSelectedGroup) {
		downloadedCount = totalSelectedDownloadsCount - pendingSelectedDownloadsCount;
		totalCount = totalSelectedDownloadsCount;
	} else if (loaderStep) {
		downloadedCount = loaderStep.itemsDownloaded;
		totalCount = loaderStep.itemsToDownload;
	} else {
		downloadedCount = 0;
		totalCount = 0;
	}

	// Show widget if download group is started
	const isDisplayed = (isDownloadGroupStarted && !isDownloadToastClosed);

	return {
		isDisplayed,
		downloadedItems: downloadedCount,
		totalItems: totalCount,
		startedDownloadGroup,
		isCheckingForUpdates: totalCount > 0 && totalCount === downloadedCount && !isDownloadingSelectedGroup && isDownloadGroupStarted,
	};
};

const mapDispatchToProps = (dispatch: Dispatch<StoreState>) => ({
	dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(DownloadGroupToast);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/DownloadGroupToast/index.tsx